import classes from "./BecomeHost.module.css"
import useStudioErstellenClick from "../../../hooks/useStudioErstellenClick";

import becomeHostImage from "../../../public/HomePage/become-host/hostImage.webp"

const BecomeHost = () => {
  const handleGastgeberClick = useStudioErstellenClick();

  return (
    <div className={classes.outsideContainer}>
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <img src={becomeHostImage} alt="Become Host" />
            </div>
            <div className={classes.textContainerOutside}>
                <div className={classes.textContainer}>
                    <h2 className={classes.title}>Werde Gastgeber & Creator.</h2>
                    <div className={classes.mainTextContainer}>
                        <span>Vermiete dein Studio und biete deine kreativen Services an. </span>
                        <span>Als Fotograf, Videograf oder Producer.</span>
                        <span>Stu verbindet dich mit Menschen, die genau nach deinem Space</span>
                        <span>und deinen Skills suchen.</span>
                    </div>
                    <div className={classes.mainTextContainerPhone}>
                        <span>Vermiete dein Studio und biete</span>
                        <span>deine kreativen Services an.</span>
                        <span>Als Fotograf, Videograf oder Producer.</span>
                    </div>
                    <div className={classes.allStudiosButtonContainer}>
                        <button onClick={handleGastgeberClick} className={`${classes.allStudiosButton} ${classes.displayNone} regularLarge`}>Gastgeber werden</button>
                        <button onClick={handleGastgeberClick} className={`${classes.allStudiosButton} ${classes.allStudiosButtonPhone} regularMiddle`}>Gastgeber werden</button>
                    </div>
                </div>
            </div>
        </div>
        <div className={classes.longLineContainer}>
            <div className={classes.longLine}></div>
        </div>
    </div>
  );
};

export default BecomeHost;